module.exports = __webpack_public_path__ + "img/unsex.b5d2cb1e.svg";